import { render, staticRenderFns } from "./AIFeedbackCursor.vue?vue&type=template&id=7fa83c13&scoped=true"
import script from "./AIFeedbackCursor.vue?vue&type=script&lang=js"
export * from "./AIFeedbackCursor.vue?vue&type=script&lang=js"
import style0 from "./AIFeedbackCursor.vue?vue&type=style&index=0&id=7fa83c13&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa83c13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fa83c13')) {
      api.createRecord('7fa83c13', component.options)
    } else {
      api.reload('7fa83c13', component.options)
    }
    module.hot.accept("./AIFeedbackCursor.vue?vue&type=template&id=7fa83c13&scoped=true", function () {
      api.rerender('7fa83c13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AIFeedbackCursor.vue"
export default component.exports